import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    detailFilters: {
      clients: 'Clients',
      operationType: 'Operation type',
      team: 'Team',
      transactions: 'Transactions',
    },
    details: 'Details',
  },
  fr: {
    detailFilters: {
      clients: 'Clients',
      operationType: "Type d'opération",
      team: 'Équipe',
      transactions: 'Transactions',
    },
    details: 'Détails',
  },
} as const);

export default locales;
